module.exports = __webpack_public_path__ + "media/honey-icons/icon-increased-73ee7323.svg";